// actions.js
import * as types from "../../actionTypes";

export const fetchStatesRequest = (keyword) => ({
  type: types.FETCH_STATES_REQUEST,
  payload: keyword ,
});

export const fetchStatesSuccess = (data) => ({
  type: types.FETCH_STATES_SUCCESS,
  payload: data ,
});

export const fetchStatesFailure = (error) => ({
  type: types.FETCH_STATES_FAILURE,
  payload:  error ,
});

